import { createActions } from '@manager-base/app-base/config/data-access';
import { BASE_PATH_API } from '@manager-base/app-base/environment/paths/constants';

const actions = {
    getUnpaidBillsSummaryForAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/bills/Company/:id/unpaid/:startDate/:endDate/summary`
    },
    getUnpaidBillsDetailsForAccount: {
        method: 'GET',
        url: `${BASE_PATH_API}/bills/Company/:id/unpaid/:startDate/:endDate/details`
    },
    getBillReportName: {
        method: 'GET',
        url: `${BASE_PATH_API}/bills/:id/reportName`
    },
    getUnpaidBillsForVendor: {
        method: 'GET',
        url: `${BASE_PATH_API}/bills/vendor/:vendorId/unpaid`,
        isArray: true
    },
    getUnpaidBillsSummaryForVendor: {
        method: 'GET',
        url: `${BASE_PATH_API}/bills/vendor/:vendorId/unpaid/summary`,
    },
    getBill: {
        method: 'GET',
        url: `${BASE_PATH_API}/bills/:billId`
    },
    updateBill: {
        method: 'PUT',
        url: `${BASE_PATH_API}/bills/:billId`
    },
    getUnusedVendorCredits: {
        method: 'GET',
        url: `${BASE_PATH_API}/bills/:billId/vendorCredits/unused`,
        isArray: true
    },
    deleteBill: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/bills/:billId`
    },
    getBillUnpaidStatus: {
        method: 'GET',
        url: `${BASE_PATH_API}/bills/:billId/unpaidStatus`
    },
    markBillAsPaid: {
        method: 'DELETE',
        url: `${BASE_PATH_API}/bills/:billId/markAsPaid`
    },
    createBills: {
        method: 'POST',
        url: `${BASE_PATH_API}/bills`
    },
    getExistingVendorBills: {
        method: 'GET',
        url: `${BASE_PATH_API}/bills/vendors/:vendorId?referenceAccountNumber=:refNo`
    },
    collectBillMarkupsInBulk: {
        method: 'POST',
        url: `${BASE_PATH_API}/bills/collectMarkupInBulk`
    },
    // Delete these two endpoints with the removal of the 'buildium-as-partial-bill-payments' flag
    getUnpaidBillsToBePaidByCheck: {
        method: 'GET',
        url: `${BASE_PATH_API}/bills/unpaid/checks`,
        params: {
            '$count': true
        }
    },
    getUnpaidBillsToBePaidByEFT: {
        method: 'GET',
        url: `${BASE_PATH_API}/bills/unpaid/eft`,
        params: {
            '$count': true
        }
    },
    // Rename this and the EFT endpoint to remove V2 with the removal of 'buildium-as-partial-bill-payments'
    getUnpaidBillsToBePaidByCheckV2: {
        method: 'GET',
        url: `${BASE_PATH_API}/bills/v2/unpaid/checks`,
        params: {
            '$count': true
        }
    },
    getUnpaidBillsToBePaidByEFTV2: {
        method: 'GET',
        url: `${BASE_PATH_API}/bills/v2/unpaid/eft`,
        params: {
            '$count': true
        }
    },
    payUnpaidBills: {
        method: 'POST',
        url: `${BASE_PATH_API}/bills/unpaid`
    },
    getMarkup: {
        method: 'GET',
        url: `${BASE_PATH_API}/bills/markup/:markupId`
    },
    getIsFromOpsTechDraftBill: {
        method: 'GET',
        url: `${BASE_PATH_API}/bills/:billId/isFromOpsTechDraftBill`
    },
    getDefaultManagementFeePolicy: {
        method: 'GET',
        url: `${BASE_PATH_API}/bills/managementFeePolicy`
    },
    getUnpaidBillsList: {
        method: 'POST',
        url: `${BASE_PATH_API}/bills/unpaidBills`,
        params: {
            '$count': true
        }
    },
    getPaidBillsListPaged: {
        method: 'POST',
        url: `${BASE_PATH_API}/bills/paidBills/paged`,
        params: {
            '$count': true
        }
    },
    getVendorCategoriesForFiltering: {
        method: 'GET',
        url: `${BASE_PATH_API}/bills/vendors/categories`
    },
    getAccountingBooksUserCanAccess: {
        method: 'GET',
        url: `${BASE_PATH_API}/bills/booksUserCanAccess`
    },
    getBillCharges: {
        method: 'GET',
        url: `${BASE_PATH_API}/bills/:billId/charges`
    },
    getEftInformationForBillPayeeVendor: {
        method: 'GET',
        url: `${BASE_PATH_API}/bills/vendor/:vendorId/eft`
    },
};

export function BillsApi() {
    const service = createActions(actions);
    service.getPrintBillUrl = function getPrintBillUrl(billId) {
        return `${BASE_PATH_API}/bills/${billId}/print`;
    };
    return service;
}
